var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#32936F",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6938 4.50629C11.6357 4.4477 11.5666 4.40121 11.4904 4.36948C11.4142 4.33775 11.3325 4.32141 11.25 4.32141C11.1675 4.32141 11.0858 4.33775 11.0097 4.36948C10.9335 4.40121 10.8644 4.4477 10.8063 4.50629L6.15003 9.16879L4.19378 7.20628C4.13345 7.14801 4.06224 7.10219 3.98421 7.07144C3.90617 7.04068 3.82284 7.0256 3.73898 7.02705C3.65512 7.02851 3.57236 7.04646 3.49544 7.07989C3.41851 7.11333 3.34893 7.16158 3.29065 7.22191C3.23238 7.28224 3.18656 7.35345 3.15581 7.43148C3.12505 7.50952 3.10997 7.59285 3.11142 7.67671C3.11287 7.76057 3.13083 7.84333 3.16426 7.92025C3.1977 7.99718 3.24595 8.06676 3.30628 8.12504L5.70628 10.525C5.76438 10.5836 5.83351 10.6301 5.90967 10.6618C5.98583 10.6936 6.06752 10.7099 6.15003 10.7099C6.23254 10.7099 6.31423 10.6936 6.39039 10.6618C6.46655 10.6301 6.53568 10.5836 6.59378 10.525L11.6938 5.42504C11.7572 5.36651 11.8079 5.29548 11.8425 5.21641C11.8771 5.13735 11.895 5.05197 11.895 4.96566C11.895 4.87935 11.8771 4.79397 11.8425 4.71491C11.8079 4.63584 11.7572 4.56481 11.6938 4.50629Z",
    fill: "#32936F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCheck);
export default __webpack_public_path__ + "static/media/VerifiedCheck.1974aaa73c6ca7015ba329b25eb20b8b.svg";
export { ForwardRef as ReactComponent };